export const tableTheme = {
  tableContainer: {
    boxShadow: '0 2px 10px 0 rgba(204, 204, 204, 0.3)',
  },
  tableHeader: {
    col: {
      padding: '0 10px',
    },
  },
  tablePagination: {
    pagerElementWidth: '34px',
    pagerElementHeight: '36px',
    pagerElementFontSize: '14px',
    pagerNumberElement: {
      selected: {
        borderRadius: '7px',
        backgroundColor: '#bed630;',
        color: 'inherit',
      },
    },
  },
};
